module.exports = __webpack_public_path__ + "static/media/evaclean2.2cf4d4c7.png";